/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { SetupParameterTemplateListValueListViewModel } from '../../models/setup-parameter-template-list-value-list-view-model';

export interface GetSetupParameterTemplateListValues$Params {
  setupParameterTemplateListValueId?: number | null;
  setupParameterTemplateId?: number | null;
  name?: string | null;
}

export function getSetupParameterTemplateListValues(http: HttpClient, rootUrl: string, params?: GetSetupParameterTemplateListValues$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<SetupParameterTemplateListValueListViewModel>>> {
  const rb = new RequestBuilder(rootUrl, getSetupParameterTemplateListValues.PATH, 'get');
  if (params) {
    rb.query('setupParameterTemplateListValueId', params.setupParameterTemplateListValueId, {});
    rb.query('setupParameterTemplateId', params.setupParameterTemplateId, {});
    rb.query('name', params.name, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<SetupParameterTemplateListValueListViewModel>>;
    })
  );
}

getSetupParameterTemplateListValues.PATH = '/api/v1/SetupParameter/GetSetupParameterTemplateListValues';
